module.exports = __webpack_public_path__ + "img/test_bg.b34023fd.jpg";